/**
 * mh-product-reviews.js
 * Drives the .mh-reviews widget rendered by snippets/mh-product-reviews.liquid.
 * Built entirely with DOM methods (createElement / textContent) — no innerHTML —
 * so user-supplied review text and image URLs can never inject markup.
 */
(function () {
  document.querySelectorAll('.mh-reviews').forEach(initWidget);

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') { /* never used */ }
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null) return;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  function makeStars(rating, sizeClass) {
    var wrap = document.createElement('span');
    if (sizeClass) wrap.className = sizeClass;
    for (var i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.className = 'mh-star' + (i > rating ? ' mh-star--empty' : '');
      s.textContent = '★';
      wrap.appendChild(s);
    }
    return wrap;
  }

  function fmtDate(s) {
    try {
      var d = new Date(String(s).replace(' ', 'T'));
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { return s; }
  }
  function initials(name) {
    if (!name) return '?';
    var parts = String(name).trim().split(/\s+/).slice(0, 2);
    return parts.map(function (p) { return p[0] || ''; }).join('').toUpperCase();
  }

  function initWidget(root) {
    var API = 'https://admin.menahub.com/api';
    var productId = root.dataset.productId;
    var productHandle = root.dataset.productHandle;
    var productTitle = root.dataset.productTitle;
    var loggedIn = root.dataset.loggedIn === '1';
    var customerId = root.dataset.customerId || '';
    var customerEmail = root.dataset.customerEmail || '';
    var customerName = root.dataset.customerName || '';

    var listEl    = root.querySelector('[data-mh-list]');
    var loadingEl = root.querySelector('[data-mh-loading]');
    var emptyEl   = root.querySelector('[data-mh-empty]');
    var avgEl     = root.querySelector('[data-mh-avg]');
    var avgStars  = root.querySelector('[data-mh-avg-stars]');
    var countEl   = root.querySelector('[data-mh-count]');
    var histEl    = root.querySelector('[data-mh-histogram]');
    var ctrlEl    = root.querySelector('[data-mh-controls]');
    var sortSel   = root.querySelector('[data-mh-sort]');
    var photosOnlyChk = root.querySelector('[data-mh-photos-only]');

    var state = { reviews: [], avg: 0, count: 0, hist: {1:0,2:0,3:0,4:0,5:0} };

    function buildCard(r) {
      var card = el('article', { 'class': 'mh-rev-card' });

      var head = el('div', { 'class': 'mh-rev-card__head' });
      head.appendChild(el('div', { 'class': 'mh-rev-card__avatar', text: initials(r.customer_name) }));

      var meta = el('div', { 'class': 'mh-rev-card__meta' });
      var nameRow = el('div', { 'class': 'mh-rev-card__name', text: r.customer_name || 'Anonymous' });
      if (r.customer_id) {
        nameRow.appendChild(el('span', { 'class': 'mh-rev-card__verified', text: '✓ Verified' }));
      }
      meta.appendChild(nameRow);
      meta.appendChild(el('div', { 'class': 'mh-rev-card__date', text: fmtDate(r.created_at) }));
      head.appendChild(meta);

      var starsWrap = makeStars(r.rating | 0, 'mh-rev-card__stars');
      head.appendChild(starsWrap);
      card.appendChild(head);

      if (r.title) {
        card.appendChild(el('div', { 'class': 'mh-rev-card__title', text: r.title }));
      }
      card.appendChild(el('p', { 'class': 'mh-rev-card__body', text: r.body || '' }));

      if (r.images && r.images.length) {
        var imgs = el('div', { 'class': 'mh-rev-card__images' });
        r.images.forEach(function (u) {
          var img = document.createElement('img');
          img.src = u; // attribute set via setAttribute path; no markup parsing
          img.alt = 'Review photo';
          img.loading = 'lazy';
          imgs.appendChild(img);
        });
        card.appendChild(imgs);
      }
      return card;
    }

    function render() {
      var reviews = state.reviews.slice();
      if (photosOnlyChk && photosOnlyChk.checked) {
        reviews = reviews.filter(function (r) { return r.images && r.images.length; });
      }
      var sort = sortSel ? sortSel.value : 'newest';
      reviews.sort(function (a, b) {
        if (sort === 'highest') return b.rating - a.rating || (b.id - a.id);
        if (sort === 'lowest')  return a.rating - b.rating || (b.id - a.id);
        if (sort === 'helpful') return (b.helpful_count|0) - (a.helpful_count|0) || (b.id - a.id);
        return b.id - a.id;
      });

      if (loadingEl && loadingEl.parentNode) loadingEl.remove();
      if (state.count === 0) {
        emptyEl.hidden = false;
        listEl.textContent = '';
        ctrlEl.hidden = true;
        histEl.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      ctrlEl.hidden = false;
      histEl.hidden = false;

      avgEl.textContent = state.avg.toFixed(1);
      avgStars.textContent = '';
      avgStars.appendChild(makeStars(Math.round(state.avg)));
      countEl.textContent = 'Based on ' + state.count + ' review' + (state.count === 1 ? '' : 's');

      for (var i = 1; i <= 5; i++) {
        var c = state.hist[i] || 0;
        var pct = state.count ? (c / state.count) * 100 : 0;
        var fill = root.querySelector('[data-mh-bar-fill="' + i + '"]');
        var cnt = root.querySelector('[data-mh-bar-count="' + i + '"]');
        if (fill) fill.style.width = pct + '%';
        if (cnt) cnt.textContent = c;
      }

      listEl.textContent = '';
      var frag = document.createDocumentFragment();
      reviews.forEach(function (r) { frag.appendChild(buildCard(r)); });
      listEl.appendChild(frag);
    }

    function load() {
      fetch(API + '/list_reviews.php?product_id=' + encodeURIComponent(productId), { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.success) { state.reviews = []; render(); return; }
          state.reviews = d.reviews || [];
          state.avg = parseFloat(d.summary && d.summary.avg) || 0;
          state.count = (d.summary && d.summary.count) || 0;
          state.hist = (d.summary && d.summary.histogram) || {1:0,2:0,3:0,4:0,5:0};
          render();
        })
        .catch(function () { state.reviews = []; render(); });
    }

    if (sortSel) sortSel.addEventListener('change', render);
    if (photosOnlyChk) photosOnlyChk.addEventListener('change', render);

    // ----- Modal -----
    var modal = root.querySelector('[data-mh-modal]');
    var openBtn = root.querySelector('[data-mh-open-modal]');
    var closeEls = root.querySelectorAll('[data-mh-modal-close]');
    var rateEls = root.querySelectorAll('[data-mh-rate]');
    var rateInput = root.querySelector('[data-mh-rating-input]');
    var rateText = root.querySelector('[data-mh-rating-text]');
    var fileInput = root.querySelector('[data-mh-file-input]');
    var uploadTrigger = root.querySelector('[data-mh-upload-trigger]');
    var previewsEl = root.querySelector('[data-mh-previews]');
    var form = root.querySelector('[data-mh-form]');
    var feedbackRow = root.querySelector('[data-mh-feedback-row]');
    var feedback = root.querySelector('[data-mh-feedback]');
    var submitBtn = root.querySelector('[data-mh-submit]');
    var submitLabel = root.querySelector('[data-mh-submit-label]');

    var pendingFiles = [];
    var ratingLabels = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];

    function openModal() {
      if (!loggedIn) return;
      modal.hidden = false;
      document.body.classList.add('mh-rmodal-open');
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('mh-rmodal-open');
    }
    function setRating(n) {
      rateInput.value = n;
      rateEls.forEach(function (el2) {
        var v = parseInt(el2.dataset.mhRate, 10);
        el2.classList.toggle('is-filled', v <= n);
      });
      rateText.textContent = ratingLabels[n] || 'Tap a star';
    }
    function setFeedback(kind, msg) {
      feedback.classList.remove('is-success', 'is-error');
      if (!kind) { feedbackRow.hidden = true; feedback.textContent = ''; return; }
      feedback.classList.add('is-' + kind);
      feedback.textContent = msg;
      feedbackRow.hidden = false;
    }
    function renderPreviews() {
      previewsEl.textContent = '';
      pendingFiles.forEach(function (f, idx) {
        var wrap = document.createElement('div');
        wrap.className = 'mh-rmodal__preview';
        var img = document.createElement('img');
        img.src = URL.createObjectURL(f);
        img.alt = '';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mh-rmodal__preview-remove';
        btn.setAttribute('aria-label', 'Remove');
        btn.textContent = '×';
        btn.addEventListener('click', function () {
          pendingFiles.splice(idx, 1);
          renderPreviews();
        });
        wrap.appendChild(img);
        wrap.appendChild(btn);
        previewsEl.appendChild(wrap);
      });
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    closeEls.forEach(function (el2) { el2.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (ev) {
      if (modal && !modal.hidden && ev.key === 'Escape') closeModal();
    });

    rateEls.forEach(function (el2) {
      el2.addEventListener('click', function () { setRating(parseInt(el2.dataset.mhRate, 10)); });
      el2.addEventListener('mouseenter', function () {
        var n = parseInt(el2.dataset.mhRate, 10);
        rateEls.forEach(function (e3) {
          e3.classList.toggle('is-filled', parseInt(e3.dataset.mhRate, 10) <= n);
        });
      });
    });
    var rateGroup = root.querySelector('[data-mh-rating]');
    if (rateGroup) rateGroup.addEventListener('mouseleave', function () {
      var n = parseInt(rateInput.value, 10) || 0;
      setRating(n);
    });

    if (uploadTrigger) uploadTrigger.addEventListener('click', function () { fileInput.click(); });
    if (fileInput) fileInput.addEventListener('change', function () {
      var files = Array.from(fileInput.files || []);
      files.forEach(function (f) {
        if (pendingFiles.length >= 5) return;
        if (!/^image\//.test(f.type)) return;
        if (f.size > 5 * 1024 * 1024) return;
        pendingFiles.push(f);
      });
      fileInput.value = '';
      renderPreviews();
    });

    if (form) form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      setFeedback(null);
      var rating = parseInt(rateInput.value, 10);
      var body = (form.body.value || '').trim();
      if (!rating) { setFeedback('error', 'Please pick a star rating.'); return; }
      if (!body) { setFeedback('error', 'Please write a few words about your experience.'); return; }

      var data = new FormData();
      data.append('product_id', productId);
      data.append('product_handle', productHandle);
      data.append('product_title', productTitle);
      data.append('customer_id', customerId);
      data.append('customer_email', customerEmail);
      data.append('customer_name', customerName);
      data.append('rating', String(rating));
      data.append('title', form.title.value || '');
      data.append('body', body);
      pendingFiles.forEach(function (f) { data.append('images[]', f); });

      submitBtn.disabled = true;
      submitLabel.textContent = 'Submitting…';

      fetch(API + '/submit_review.php', { method: 'POST', body: data, credentials: 'omit' })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (res.body && res.body.success) {
            setFeedback('success', res.body.message || 'Thanks for your review!');
            setTimeout(function () {
              closeModal(); load();
              form.reset(); pendingFiles = []; renderPreviews(); setRating(0); setFeedback(null);
            }, 1200);
          } else {
            setFeedback('error', (res.body && res.body.message) || 'Could not submit your review. Try again.');
          }
        })
        .catch(function () { setFeedback('error', 'Network error. Please try again.'); })
        .finally(function () {
          submitBtn.disabled = false;
          submitLabel.textContent = 'Submit review';
        });
    });

    root.addEventListener('click', function (ev) {
      var img = ev.target.closest('.mh-rev-card__images img');
      if (!img) return;
      window.open(img.src, '_blank', 'noopener');
    });

    load();
  }
})();
